import { h } from 'preact'
import Header from '../header'
import MethodBox from './MethodBox'
import Key from '../assets/key'
import Flag from '../ui-components/Flag'
import ButtonControl from '../button-control'
import DefaultAuthenticationBox from './DefaultAuthenticationBox'

import { Provider, ProviderList } from './types'

interface Props {
  isDefaultAuthenticationEnabled: boolean,
  toggleProviderVisibility: (provider?: Provider) => void,
  providers: ProviderList
}

const SSOOverviewPresenter = ({ isDefaultAuthenticationEnabled, toggleProviderVisibility, providers }: Props) =>
  <div>
    <Header
      title='SSO'
      disableCancelButton
      disableSaveButton
    />
    <div class='sso-overview sso-settings'>
      <div className='sso-method-title'>Default authentication method</div>
      <DefaultAuthenticationBox
        isEnabled={isDefaultAuthenticationEnabled}
        toggle={toggleProviderVisibility}
      />
      <div className='sso-method-title'>SSO method</div>
      {providers.map((provider: Provider) => {
        const { isEnabled, isInstalled } = provider

        function getButtonProps () {
          return {
            title: isInstalled ? 'Edit' : 'Install',
            variant: isInstalled ? 'secondary' : 'primary',
            onClick: isInstalled ? () => provider.onEdit(provider) : () => provider.onInstall(provider),
            class: isInstalled ? `sso-overview__${provider.name}-edit` : `sso-overview__${provider.name}-install`
          }
        }

        return <MethodBox providerName={provider.name}>
          { provider.color && <Key color={provider.color} /> }
          { provider.image && <img src={provider.image} width={48} /> }
          <div className={`method method-${provider.name}`}>{provider.label}</div>
          {isInstalled && !(isInstalled && isEnabled) && <Flag text='Installed' secondary />}
          {isEnabled && <Flag text='Enabled' success />}
          <ButtonControl {...getButtonProps()} />
        </MethodBox>
      })}
    </div>
  </div>

export default SSOOverviewPresenter
